( function ($) {

    // START widget virtual 
    let _widget = $('.form.banner-form');
    let _widgetOffsetTop = _widget.offset() ? _widget.offset().top : 0;
    let _widgetScrollLimit = _widgetOffsetTop + _widget.outerHeight();
    let offset = 25;
    // let _virtualWidhetHolder = _widget.clone();
    // _virtualWidhetHolder.empty();
    // _virtualWidhetHolder.id = "virtual_widget_holder";
    // _virtualWidhetHolder.addClass('d-none');
    // _widget.parent().append(_virtualWidhetHolder);

    const _widgetScrollLimitReset = () => _widgetScrollLimit = _widgetOffsetTop + _widget.outerHeight();

    const _widgetScrollHandler = () => {
        if(document.documentElement.scrollTop + offset > _widgetScrollLimit)
        {
            if(_widget.hasClass("fixed")){
                return;
            }
            // _virtualWidhetHolder.height(_widget.height());
            // _virtualWidhetHolder.width(_widget.width());
            _widget.css('top', `-${_widget.height()}px`);

            setTimeout(() => {
                // _virtualWidhetHolder.removeClass('d-none');
                _widget.addClass("fixed");
            }, 50);
            
            setTimeout(() => {
                _widget.css('top', `0px`);
            }, 60);
        }
        else
        {
            // _virtualWidhetHolder.addClass('d-none');
            // _virtualWidhetHolder.remove();
            _widget.removeClass("fixed");
        }
    }
    document.addEventListener('scroll', (e) => _widgetScrollHandler());
    _widgetScrollHandler();
    // END widget virtual 

    /**
     * if we have some query string parameters on page load in Browser Session, we set the header form
     * and post to get the related requirements
     */
    $(function () {
        let selectedPassport    = $('.visa-application-select-form select[name="passport"]').val();
        let selectedDestination = $('.visa-application-select-form select[name="destinations[0]"]').val();

        if(selectedPassport && selectedDestination){
            let queryString = $('.visa-application-select-form').serialize();
            submitVisaSelectForm(false, queryString);
            return;
        }

        // get parameters from browser's sessionStorage (similar to localStorage)
        let queryString = sessionStorage.getItem("application");

        // if we have a querystring from browser, that one gets presedence over the localStorage
        if ( window.location.search.length && containsValidUrlParameters(window.location.search) ) {
            queryString = window.location.search.replace('?', '');
        }

        if ( queryString && queryString.length ) {
            submitVisaSelectForm(false, queryString);
        }
    });

    $(function () {
        let selectedPassport    = $('.visa-immigration-select-form select[name="passport"]').val();
        let selectedDestination = $('.visa-immigration-select-form select[name="destinations[0]"]').val();

        if(selectedPassport && selectedDestination){
            let queryString = $('.visa-immigration-select-form').serialize();
            submitVisaSelectForm(false, queryString, true);
            return;
        }

        // get parameters from browser's sessionStorage (similar to localStorage)
        let queryString = sessionStorage.getItem("application");

        // if we have a querystring from browser, that one gets presedence over the localStorage
        if ( window.location.search.length && containsValidUrlParameters(window.location.search) ) {
            queryString = window.location.search.replace('?', '');
        }

        if ( queryString && queryString.length ) {
            submitVisaSelectForm(false, queryString);
        }
    });

    // Check for valid url GET parameters
    function containsValidUrlParameters(queryString) {
        let allowed = [ 'passport', 'destinations', 'purposes', 'entry_types', 'validity_types' ];

        for (let i = 0; i < allowed.length; i++) {
            if ( queryString.indexOf(allowed[ i ]) === -1 ) {
                return false;
            }
        }

        return true;
    }

    /**
     * @param data
     */
    function setSession(data) {

        // remove the _token part
        data = data.replace(/_token.+?&/, '');
        var landing = "";
        if(window.location.href.indexOf("immigration") > -1){
            data += "&isImmigration=1";
            landing = "immigration";
            window.history.pushState(null, null, ( landing + '?' + data ));
            return;
        }


        sessionStorage.setItem('application', data);
        // change query string without reload ing page
        window.history.pushState(null, null, ( landing + '?' + data ));
    }

    /**
     * Save to session in browser (similar to localStorage) on every change
     * This is different from the laravel session 'application' which is in cookie.
     */
    
    $(document).on('change', '.visa-immigration-select-form select', function () {
        $(this).removeClass('is-invalid');
        setSession($(this).parents('form').serialize());
    });
    $(document).on('change', '.visa-application-select-form select', function () {
        $(this).removeClass('is-invalid');
        setSession($(this).parents('form').serialize());
    });

    /**
     * Submit the form with ajax when the destination select changes.
     * This is the first step in the visa requirements check form.
     */
    $(document).on('change', '.visa-immigration-select-form .passport_select', function () {
        submitVisaSelectForm();
    });
    $(document).on('change', '.visa-application-select-form .passport_select', function () {
        submitVisaSelectForm();
    });

    /**
     * Submit the form with ajax when the nationality country select changes.
     * This is the first step in the visa requirements check form.
     */
    $(document).on('change', '.visa-immigration-select-form .residency_country_select', function () {
        submitVisaSelectForm();
    });
    $(document).on('change', '.visa-application-select-form .residency_country_select', function () {
        submitVisaSelectForm();
    });

    /**
     * Submit the form with ajax when the destination select changes.
     * This is the first step in the visa requirements check form.
     */
    $(document).on('change', '.visa-immigration-select-form .destination_select', function () {
        submitVisaSelectForm();
    });
    $(document).on('change', '.visa-application-select-form .destination_select', function () {
        submitVisaSelectForm();
    });

    /**
     * Submit the form with ajax when the entry type select changes.
     * This is the third step in the visa requirements model popup form.
     */
    $(document).on('change', '.visa-immigration-select-form .entry_type_select', function () {
        submitVisaSelectForm();
    });
    $(document).on('change', '.visa-application-select-form .entry_type_select', function () {
        submitVisaSelectForm();
    });

    /**
     * Catch the visa application form submit and submit it with ajax.
     * This is the second step in the visa requirements check form,
     * when a user clicks on the submit button.
     *
     * We then check if the visa application has any required entry types.
     */
    $(document).on('click', '.btn-open-modal', function () {

        let allTravelPurposeHaveAValue = true;
        // we only get entry types, if we have a travel purpose for each selected destination
        $('.visa-application-select-form .destination_select:visible,.visa-immigration-select-form .destination_select:visible, .visa-application-select-form .purpose_select:visible,.visa-immigration-select-form .purpose_select:visible').each(function () {
            if ( !$(this).val() ) {
                $(this).addClass('is-invalid');
                allTravelPurposeHaveAValue = false;
            }
        });

        if ( allTravelPurposeHaveAValue ) {
            submitVisaSelectForm(true);
        }
    });

    /**
     * Submit the Visa check form and receive the application object.
     * This object holds all the destinations and
     * required travel purposes, entry types and validity types.
     *
     * The returned object is a json representation of our backend Application Model.
     */
    function submitVisaSelectForm(openModal, parameters, isImmigration) {
        let form = $(".visa-application-select-form");
        if(isImmigration)
            form = $(".visa-immigration-select-form");

        if ( form.length ) {
            if ( !parameters ) {
                // if no parameters, get them serialized from the form.
                parameters = form.serialize();
            } else {
                // else we have already parameters, so we need to re-populate the form
                repopulateForm(openModal, parameters, form);
            }
            if(isImmigration)
                parameters += "&isImmigration=1";

            $.ajax({
                type: "GET",
                url: form.data('checkvisarequirements-route'),
                data: parameters,
                success: function (data) {
                    populateFormWithApplicationData(data.data, isImmigration);
                    if ( openModal ) {
                        showVisaCheckSuccessModel();
                    }
                },
                error: function (xhr) {
                    if ( xhr.status === 422 ) {
                        showVisaCheckAlertModal(JSON.parse(xhr.responseText).errors);
                    }
                }
            });
        }
    }

    /**
     * Repopulate the form based on parameters
     * @param openModal
     * @param parameters
     * @param form
     */
    function repopulateForm(openModal, parameters, form) {
        let parametersObject = unserialize(parameters);

        Object.keys(parametersObject).forEach(function (key, index) {

            let field = form.find('[name="' + key + '"]');

            if ( field.length ) {
                let parent = field.parents('.new_row');
                if ( parent.length && parent.hasClass('d-none') ) {
                    parent.removeClass('d-none');
                }
                field.val(parametersObject[ key ]);
                field.attr('disabled', false);
            } else if ( key.includes("destinations") || key.includes("purposes") ) {
                toggleVisaSelectHeaderFormFields();
                submitVisaSelectForm(openModal, parameters);
            }
        });
    }

    /**
     * Render a server side generated list of validation messages
     * @param messages
     */
    function showVisaCheckAlertModal(messages) {

        $('#mainPageModal .error-message ul').html('');

        $.each(messages, function (i, message) {
            $('#mainPageModal .error-message ul').append('<li>' + message.toString() + '</li>');
        });

        $('#mainPageModal .entry_and_validity_fields').addClass('d-none');
        $('#mainPageModal .error-message').removeClass('d-none');
        $('#mainPageModal').modal('show');
    }

    /**
     * Open the entry type and validity type select modal
     */
    function showVisaCheckSuccessModel() {
        $('#mainPageModal .entry_and_validity_fields').removeClass('d-none');
        $('#mainPageModal .error-message').addClass('d-none');
        $('#mainPageModal').modal('show');
    }

    /**
     * If we have all required data,
     * Lets proceed to the Visa Application page
     */
    function redirectToVisaApplicationPage() {

    }

    /**
     * Set all select options for the complete form.
     * This means all Travel Purposes, Entry Types and Validaty Types
     *
     * @param application
     */
    function populateFormWithApplicationData(application, isImmigration) {
        if ( application && typeof application.destinations !== 'undefined' ) {

            toggleVisaSelectModalFormFields(application.destinations);

            $.each(application.destinations, function (i, destination) {
                populateSelectFieldsForDestination(destination, isImmigration);
            });
        }
    }

    /**
     * Set all the select boxes related to a selected destination.
     * This will also empty the selects if no options are returned.
     *
     * @param destination
     */
    function populateSelectFieldsForDestination(destination, isImmigration) {

        // set the Destination DropDowns
        populateSelectField(
            $('[name="destinations[' + destination.index + ']"]'),
            isImmigration ? destination.available_destinations_immigration : destination.available_destinations,
            destination.country_id
        );

        // set the Travel Purposes DropDowns
        populateSelectField(
            $('[name="purposes[' + destination.index + ']"]'),
            destination.available_travel_purposes,
            destination.travel_purpose_id
        );

        // set the Entry Type DropDowns
        populateSelectField(
            $('[name="entry_types[' + destination.index + ']"]'),
            destination.available_entry_types,
            destination.entry_type_id
        );

        // set the Validity Type DropDowns
        populateSelectField(
            $('[name="validity_types[' + destination.index + ']"]'),
            destination.available_validity_types,
            destination.validity_type_id
        );
    }

    /**
     * Populate a dropdown select field with options
     * @param field the jQuery field object
     * @param options an array of objects item.id, item.name
     * @param selected optional selected value
     */
    function populateSelectField(field, options, selected) {

        let firstOption = $("#select").attr('data-select');

        if ( firstOption && firstOption.length ) {
            field.html('<option value="">' + firstOption + '</option>');
        }

        if ( options ) {
            let popular_count = parseInt(field.attr('data-popularcount'));

            options.forEach(function (option, index) {
                let select = option.id === selected ? 'selected' : '';

                field.append('<option value="' + option.id + '" ' + select + '>' + option.name + '</option>');

                if ( popular_count && index + 1 === popular_count ) {
                    field.append('<option disabled>---------</option>');
                }
            });


            if ( selected ) {
                field.find('option:first-child').attr('disabled', true);
            }
            else {
                field.find('option:first-child').attr('disabled', false);
                if ( options.length === 1 ) {
                    field.find('option:last-child').prop('selected', true);
                    submitVisaSelectForm(false, false);
                }
            }

        }
    }

    /**
     *  Add new rows for destination, travel purpose
     */
    $('.visa-application-select-form .form__see-more').click(function (e) {
        e.preventDefault();
        toggleVisaSelectHeaderFormFields(true);
        
        // set new limit for virtual widget!
        _widgetScrollLimitReset()
    });

    /**
     * Duplicate destination, travel purpose fields in the header form.
     * We don't duplicate the passport field, so there is a hidden second row without passport already in the html
     */
    function toggleVisaSelectHeaderFormFields(reset) {
        let rows = $('.rows-wrapper .new_row');

        if ( rows.length < 3 ) {
            // the first extra row is hidden and is the one we clone
            if ( rows.eq(0).hasClass('d-none') ) {
                rows.eq(0).removeClass('d-none');
                rows.eq(0).find('select').prop('disabled', false);
            } else {
                rows.eq(0).clone().appendTo(".banner-form .rows-wrapper");
                let added = $('.rows-wrapper .new_row:last-child');
                let newNum = rows.length + 1;

                added.attr('data-num', newNum).removeClass('d-none');
                added.find('.destination_select').attr('name', 'destinations[' + newNum + ']');

                added.find('.purpose_select').attr('name', 'purposes[' + newNum + ']');
                added.find('.purpose_select option:selected').attr('selected', false);

                if ( reset ) {
                    added.find('.destination_select option').attr('disabled', false).attr('selected', false);
                }
            }
        }
    }

    /**
     * Duplicate entry type and validity type in the modal form
     * Ever field set is the same, that is why this method is slightly
     * different then toggleVisaSelectHeaderFormFields()
     *
     * We only append a new set of fields if we have a destination
     */
    function toggleVisaSelectModalFormFields(destinations) {

        $('.entry_and_validity_fields').removeClass('d-none');

        // first remove items we don't have a destination for
        $('.entry_type_wrapper .new_row:gt(' + destinations.length + ')').remove();

        $.each(destinations, function (i, destination) {

            // the row might already exists...
            let num = destination.index;
            let existing = $('.entry_type_wrapper .new_row[data-num="' + num + '"]');
            let hasEntries = destination.available_entry_types && destination.available_entry_types.length;

            if ( existing.length && hasEntries ) {
                // if we have already a set of fields
                // and we have entries
                // make sure we show the correct name of the destination in the heading
                existing.find('.modal_country_name').text(destination.name);
            } else if ( existing.length && !hasEntries ) {
                // we don't have any entry types for this destination
                // remove the field set, except the first one
                if ( num ) existing.remove();
            } else {
                // we don't have a field set yet for this destination
                // and we do have entries
                // so  create a new row of fields
                $('.entry_type_wrapper .new_row:eq(0)').clone().appendTo(".entry_type_wrapper");
                let added = $('.entry_type_wrapper .new_row:last-child');
                added.attr('data-num', num);
                added.find('.modal_country_name').text(destination.name);
                added.find('.entry_type_select').attr('name', 'entry_types[' + num + ']');
                added.find('.validity_type_select').attr('name', 'validity_types[' + num + ']');
            }

        });
    }

    /**
     * Remove destination rows on click
     */
    $(document).on('click', '.remove-destination-row', function () {
        let row = $(this).parents('.new_row');

        let new_rows = $(this).parents('.rows-wrapper').find('.new_row');

        if ( new_rows.length === 1 ) {
            row.addClass('d-none');
            row.attr('data-num', 1);
            row.find('[name^="destinations"]').attr({'name': 'destinations[1]', 'disabled': true}).val('');
            row.find('[name^="purposes"]').attr({'name': 'purposes[1]', 'disabled': true}).val('');
        } else {
            let wrapper = row.parents('.rows-wrapper');
            row.remove();

            wrapper.find('.new_row').each(function (index, el) {
                index = parseInt(index);
                $(el).attr('data-num', index + 1);
                $(el).find('[name^="destinations"]').attr('name', 'destinations[' + ( index + 1 ) + ']').val('');
                $(el).find('[name^="purposes"]').attr('name', 'purposes[' + ( index + 1 ) + ']').val('');
            });
        }

        $('.entry_type_wrapper .new_row[data-num="' + new_rows.length + '"]').remove();
        var parameters = $('.visa-application-select-form').serialize();
        if(window.location.href.indexOf("immigration") > -1)
            parameters += "&isImmigration=1";
        setSession(parameters);

        // set new limit for virtual widget!
        _widgetScrollLimitReset()
    });

    /**
     * Unserialize already serialized data into object
     * @param serialize
     */
    function unserialize(serialize) {
        let obj = {};
        serialize = serialize.split('&');
        for (let i = 0; i < serialize.length; i++) {
            let thisItem = serialize[ i ].split('=');
            if ( thisItem[ 1 ] !== 'Selecteer' ) {
                obj[ decodeURIComponent(thisItem[ 0 ]) ] = decodeURIComponent(thisItem[ 1 ]);
            }
        }
        delete obj._token;
        return obj;
    }

}(jQuery) );
